/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import { Button, OverlayTrigger, Dropdown, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  tabValue,
  saveEnable,
  createRebatePgmDetail,
  createRebateErrorMsg,
  createFieldErr,
  createRebateProgramApi,
  defaultAuditCheck,
  getCmsFreezeQtr,
  getOverrideDefaultData,
  getEnrollGridData,
  getMaxQtrEnroll,
  getLastFrozenQtr,
  getRebatePgmDetail,
  getUseDefAuditsInd,
  getAuditGridList,
  getUnitTypeAuditGridList,
} from './store/actions';
import { getPlanTypes } from '../SearchRebate/store/actions';
import DetailsTab from '../DetailsTab';
import InvoiceDetailsTab from '../InvoiceDetailsTab';
import IntShareTab from '../IntShareTab';
import URATab from '../URATab';
import DefaultOverrideTab from '../DefaultOverrideTab';
import AuditsTab from '../AuditsTab';
import UnitTypeAuditTab from '../UnitTypeAuditTab';
import GroupTab from '../GroupTab';
import EnrollmentTab from '../EnrollmentTab';
import {
  // saveValidation,
  fieldValidation,
  qtrHandler,
  addTableRecord,
  deleteTableRecord,
  pgmDetailsPayload,
  URAPayload,
  IntSharePayload,
  GroupPayload,
  EnrollmentPayload,
  getAuditPayload,
  getUnitAuditPayload,
  tableFldBlurAction,
  enrollTabValidation,
  uraTabValidation,
  intTabValidation,
  groupTabValidation,
  unitTypeTabValidation,
  auditTabValidation,
  detailsInvoiceOverrideTabsValidations,
  mergeSysDefOverrides,
  isValidRebatePgm,
  defaultDataForAudits,
  uraSourceChk,
  uraCalcChk,
  uraPayChk,
  intCalcChk,
  intFedaralChk,
  intFedFamilyChk,
  cmsReportingChk,
  cmsUtilizationChk,
  auditTabDataCons,
  uraPmryPayload,
  intPmryPayload,
  grpPmryPayload,
  enrollPmryPayload,
} from '../CommonTabAction';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as Messages from '../RebatePgmConstants';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  closeTab,
  compareQtrs,
  convertQuaterToDate,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionType from './store/actionTypes';
import {
  removeErr,
  makeFormDirty,
  tabHighLigther,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { getExistingCorrLinkIds, getClaimCodeList } from '../store/actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  getOverrideSystemData,
  saveUpdateRebatePgm,
} from '../MaintainRebate/store/actions';
import {
  SUCCESSMESSAGE_GENERIC,
  FAILED_MESSAGE_GENERIC,
} from '../../../../SharedModules/Errors/constantMessageData';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';
import NumberFormatCustomSix from '../../../../SharedModules/NumberFormat/NumberFormatSix';

const CreateRebate = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const capstyle = { textTransform: 'capitalize' };

  const [radioList, setRadioList] = React.useState([]);
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [linkTable, setLinkTable] = React.useState('');
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [enrollParams, setEnrollParams] = React.useState();
  // const [errorMessage, setErrorMessage] = React.useState('');
  // const [errorPopup, setErrorPopup] = React.useState(false);
  const [confimPopup, setConfimPopup] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [saveMsg, setSaveMsg] = React.useState([]);
  const [uraSrcErr, setUraSrcErr] = React.useState(false);
  const [uraCalcErr, setUraCalcErr] = React.useState(false);
  const [uraPayErr, setUraPayErr] = React.useState(false);
  const [intCalErr, setIntCalErr] = React.useState(false);
  const [intFederr, setIntFedErr] = React.useState(false);
  const [intFmlyErr, setIntFmlyErr] = React.useState(false);
  const [cmsRptErr, setCmsRptErr] = React.useState(false);
  const [cmsUtilErr, setCmsUtilErr] = React.useState(false);
  const [enrollErr, setEnrollErr] = React.useState(false);
  const [unitErr, setUnitErr] = React.useState(false);
  const [load, setLoad] = React.useState(true);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteInd, setDeleteInd] = React.useState(null);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const save_disable = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_save_disable
  );
  const plan_list = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.plan_list
  );

  const plan_type = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.plan_type
  );

  const activeTab = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.active_tab
  );

  const create_fld_err = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.create_fld_err
  );

  const create_pgm_detail = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
  );

  const copy_create_pgm_detail = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.copy_create_pgm_detail
  );

  const create_err_msg = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
  );

  const makeItDirty = () => {
    dispatch(saveEnable(false));
    makeFormDirty(Messages.CREATE_NEW, true);
  };

  const handleFullScreen = (val) => {
    setFullScreen(val);
  };

  const addFnErrHandler = (errors, list) => {
    let err = removeErr(list, errors);
    err = [...err, ...errors];
    dispatch(createRebateErrorMsg(err));
  };

  /* URA Tab Grid : Start */
  const create_ura_grid_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
  );
  const copy_ura_grid_data = useSelector(
    (state) =>
      state?.sharedState?.CreateRebateReducer?.create_copy_ura_grid_data
  );
  const CR_deleted_ura_src = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_ura_src
  );
  const cr_deleted_ura_calc = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_ura_calc
  );
  const CR_deleted_ura_pay = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_ura_pay
  );
  const last_frozen_qtr = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.CR_last_frozen_qtr
  );
  const last_ura_src_calc_qtr = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.CR_last_ura_src_calc_qtr
  );

  const uraChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    let tabdata = { ...record };
    let grid;
    if (table === 'src') grid = [...record.rpcUraSource];
    if (table === 'calc') grid = [...record.rpcUraCal];
    if (table === 'pay') grid = [...record.rpcUrPayment];
    let data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'src') tabdata.rpcUraSource = data.newdata;
    if (table === 'calc') tabdata.rpcUraCal = data.newdata;
    if (table === 'pay') tabdata.rpcUrPayment = data.newdata;
    let li = tabdata.rpcUraSource.filter((obj) => obj.rpcParamValue === 'CALC');
    if (li.length === 0 && table === 'src') {
      let deletedOld = tabdata.rpcUraCal.filter((o) => !o.newFlag);
      dispatch({
        type: actionType.CR_DELETED_URA_CALC,
        payload: [...cr_deleted_ura_calc, ...deletedOld],
      });
      tabdata.rpcUraCal = [];

      const rmCalcErr = data?.err.filter((erVal) => {
        if (erVal.indexOf('URA Calculation') === -1) {
          return erVal;
        }
      });
      dispatch(createRebateErrorMsg(rmCalcErr));
    }
    if (blur) dispatch(createRebateErrorMsg(data.err));
    dispatch({ type: actionType.CR_URA_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const frameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const create_ura_grid_data = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const create_err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        <TextField
          id="strtQtr"
          className={
            cellInfo.data?.startQtrErr ? 'td-active-cell tBill-validate' : ''
          }
          InputProps={{ id: 'strtQtr' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.startQtr || ''}
          onChange={(e) => {
            let data = qtrHandler(
              e.target.value,
              cellInfo,
              false,
              create_ura_grid_data,
              create_err_msg,
              'src',
              'startQtr'
            );
            dispatch({
              type: actionType.CR_URA_GRID_DATA,
              payload: data.tabdata,
            });
            makeItDirty();
            cellInfo.api.refreshCells();
          }}
          inputProps={{ maxLength:6 }}
          onBlur={(e) => {
            let data = qtrHandler(
              e.target.value,
              cellInfo,
              true,
              create_ura_grid_data,
              create_err_msg,
              'src',
              'startQtr'
            );
            dispatch({
              type: actionType.CR_URA_GRID_DATA,
              payload: data.tabdata,
            });
            dispatch(createRebateErrorMsg([...new Set([...data.err])]));
            cellInfo.api.refreshCells();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              let data = { ...create_ura_grid_data };
              let tableData = [...data.rpcUraSource];
              data.rpcUraSource = tableData.map((obj, ind) => {
                if (obj.id === cellInfo.data.id) obj.dropdownFocus = true;
                return obj;
              });
              dispatch({ type: actionType.CR_URA_GRID_DATA, payload: data });
            }
          }}
        />
      );
    },
    DropdownRenderer: (cellInfo) => {
      const ura_source = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.ura_source
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const create_err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      const [dropDownFocus, setDropDownFocus] = React.useState(false);
      return (
        <TextField
          id="uraHandler"
          style={{ width: '150px' }}
          InputProps={{ id: 'uraHandler' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.rpcParamValue || ''}
          select
          onChange={(e) => {
            let ind = cellInfo.node.rowIndex;
            let value = e.target.value;
            uraChangehandler(
              value,
              'rpcParamValue',
              ind,
              'src',
              grid,
              false,
              create_err_msg
            );
            cellInfo.api.refreshCells();
          }}
          autoFocus={cellInfo.data.dropdownFocus || dropDownFocus}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              let data = { ...grid };
              let tableData = [...data.rpcUraSource];
              data.rpcUraSource = tableData.map((obj) => {
                if (obj.id === cellInfo.data.id) obj.dropdownFocus = false;
                return obj;
              });
              setDropDownFocus(false);
              dispatch({ type: actionType.CR_URA_GRID_DATA, payload: data });
              // setTimeout(() => uraRecordAdd('src', grid, create_err_msg), 200);
            }
            if (e.key === 'Enter') setDropDownFocus(true);
          }}
        >
          <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
          {ura_source &&
            ura_source.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const create_ura_grid_data = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       uraChangehandler(val, 'delete', ind, 'src', create_ura_grid_data);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => uraRecordAdd('src', create_ura_grid_data, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({
                  table: 'src',
                  grid: create_ura_grid_data,
                  data: cellInfo,
                });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const uraRecordAdd = (table, grid, err) => {
    let data = grid ? { ...grid } : { ...create_ura_grid_data };
    let error = err ? [...err] : [...create_err_msg];
    if (table === 'src') {
      let newdata = uraSourceChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_URA_GRID_DATA,
          payload: { ...data, rpcUraSource: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'calc') {
      if (
        data.rpcUraSource.some((obj) => obj.rpcParamValue === 'CALC') === false
      )
        return;

      let newdata = uraCalcChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_URA_GRID_DATA,
          payload: { ...data, rpcUraCal: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'pay') {
      if (create_pgm_detail.planTypeCd === 'FD') return;

      let newdata = uraPayChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_URA_GRID_DATA,
          payload: { ...data, rpcUrPayment: newdata.newdata },
        });
        return;
      }
    }
    let plan = create_pgm_detail.planTypeCd;
    // let data = { ...ura_grid_data };
    let uraData = addTableRecord(
      table,
      data,
      create_pgm_detail.rebateProgramCd,
      plan,
      logInUser
    );
    dispatch({ type: actionType.CR_URA_GRID_DATA, payload: uraData });
    if (table === 'calc') {
      let err = removeErr(create_err_msg, [Messages.URA_CALC_REQ]);
      dispatch(createRebateErrorMsg(err));
    }
    if (table === 'src') {
      let err = removeErr(create_err_msg, [Messages.URA_ERR]);
      dispatch(createRebateErrorMsg(err));
    }
    makeItDirty();
  };

  // const uraRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...create_ura_grid_data,
  //   });
  //   if (table === 'src')
  //     dispatch({
  //       type: actionType.CR_DELETED_URA_SOURCE,
  //       payload: [...CR_deleted_ura_src, ...deletedOld],
  //     });
  //   if (table === 'calc')
  //     dispatch({
  //       type: actionType.CR_DELETED_URA_CALC,
  //       payload: [...cr_deleted_ura_calc, ...deletedOld],
  //     });
  //   if (table === 'pay')
  //     dispatch({
  //       type: actionType.CR_DELETED_URA_PAY,
  //       payload: [...CR_deleted_ura_pay, ...deletedOld],
  //     });
  //   err = removeErr([...create_err_msg], err);
  //   dispatch(createRebateErrorMsg(err));
  //   dispatch({ type: actionType.CR_URA_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };,

  const uraCalcFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      const last_frozen_qtr = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.CR_last_frozen_qtr
      );
      const CR_last_ura_src_calc_qtr = useSelector(
        (state) =>
          state?.sharedState?.CreateRebateReducer?.CR_last_ura_src_calc_qtr
      );

      const onChange = (e, cellInfo, blur, key) => {
        let ind = cellInfo.node.rowIndex;

        let value;

        if (key === 'calcFixedPct' || key === 'calcGenericPct') {
          if (e.target.value && e.target.value.includes('.')) {
            if (AppConstants.BAL_PERCENT_REGEX.test(e.target.value)) {
              value = e.target.value;
            } else {
              return false;
            }
          } else {
            if (AppConstants.RX_WITHOUT.test(e.target.value)) {
              value = e.target.value;
            } else {
              return false;
            }
          }
        } else {
          value = e.target.value;
        }

        uraChangehandler(value, key, ind, 'calc', grid, blur, err_msg);
      };

      return (
        <>
          {cellInfo.column.colId === 'effectiveQtr' && (
            <TextField
              id="qtrHandler2"
              className={
                cellInfo.data?.effectiveQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputProps={{ id: 'qtrHandler2' }}
              inputProps={{maxLength: 6}}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.effectiveQtr}
              onChange={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'calc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.CR_URA_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              onBlur={(e) => {
                let { tabdata, err } = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'calc',
                  'effectiveQtr',
                  true,
                  last_frozen_qtr,
                  CR_last_ura_src_calc_qtr
                );
                dispatch({
                  type: actionType.CR_URA_GRID_DATA,
                  payload: tabdata,
                });
                dispatch(createRebateErrorMsg([...new Set([...err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'calcFixedPct' && (
            <TextField
              id="calcfixedpact1"
              inputProps={{ maxLength: 16, id: 'calcfixedpact1' }}
              InputLabelProps={{ shrink: true }}
              className={
                cellInfo.data?.calcFixedPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              value={cellInfo.data.calcFixedPct}
              onChange={(e) => onChange(e, cellInfo, false, 'calcFixedPct')}
              onBlur={(e) => onChange(e, cellInfo, true, 'calcFixedPct')}
              disabled={
                cellInfo.data.calcMethodCd === 'CMSPRI' ||
                cellInfo.data.calcMethodCd === 'CONTRACT'
              }
            />
          )}
          {cellInfo.column.colId === 'calcGenericPct' && (
            <TextField
              id="calcGenericPct1"
              inputProps={{ maxLength: 16, id: 'calcGenericPct1' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.calcGenericPct}
              className={
                cellInfo.data?.calcGenericPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => onChange(e, cellInfo, false, 'calcGenericPct')}
              onBlur={(e) => onChange(e, cellInfo, true, 'calcGenericPct')}
              disabled={
                cellInfo.data.calcMethodCd === 'CMSPRI' ||
                cellInfo.data.calcMethodCd === 'CONTRACT' ||
                cellInfo.data.calcMethodCd === 'AMP' ||
                cellInfo.data.calcMethodCd === 'CMSAWP'
              }
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   uraRecordAdd('calc', grid, err_msg);
                // }
              }}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const ura_calc = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.ura_calc
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );

      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      return (
        <TextField
          id="calcGenericPct2"
          style={{ width: '150px' }}
          InputProps={{ id: 'calcGenericPct2' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.calcMethodCd || ''}
          className={
            cellInfo.data?.calcMethodCdErr
              ? 'td-active-cell tBill-validate'
              : ''
          }
          select
          onChange={(e) => {
            let val = e.target.value;
            let ind = cellInfo.node.rowIndex;
            uraChangehandler(val, 'calcMethodCd', ind, 'calc', grid, true, err);
            if (
              cellInfo.data.calcMethodCd === 'CMSPRI' ||
              cellInfo.data.calcMethodCd === 'CONTRACT'
            ) {
              let ind = cellInfo.node.rowIndex;
              uraChangehandler(
                '',
                'calcFixedPct',
                ind,
                'calc',
                grid,
                false,
                err
              );
            }

            if (
              cellInfo.data.calcMethodCd === 'CMSPRI' ||
              cellInfo.data.calcMethodCd === 'CONTRACT' ||
              cellInfo.data.calcMethodCd === 'AMP' ||
              cellInfo.data.calcMethodCd === 'CMSAWP'
            ) {
              let ind = cellInfo.node.rowIndex;
              uraChangehandler(
                '',
                'calcGenericPct',
                ind,
                'calc',
                grid,
                false,
                err
              );
            }
          }}
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1">
            {''}
          </MenuItem>
          {ura_calc &&
            ura_calc.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       uraChangehandler(val, 'delete', ind, 'calc', grid);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add URA Calculation"
              variant="text"
              disabled={
                !grid.rpcUraSource.some((o) => o.rpcParamValue === 'CALC')
              }
              onClick={() => uraRecordAdd('calc', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'calc', grid: grid, data: cellInfo });
              }}
              disabled={
                !grid.rpcUraSource.some((o) => o.rpcParamValue === 'CALC')
              }
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const payFrameworkComponent = {
    TextBoxRenderer: (cellInfo) => {
      const ura_grid_data = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      return (
        <TextField
          id="calcGenericPct4"
          className={
            cellInfo.data?.startQtrErr ? 'td-active-cell tBill-validate' : ''
          }
          inputProps={{ maxLength:6 }}
          InputProps={{ id: 'calcGenericPct4' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.startQtr || ''}
          onChange={(e) => {
            let data = qtrHandler(
              e.target.value,
              cellInfo,
              false,
              ura_grid_data,
              err_msg,
              'pay',
              'startQtr'
            );
            dispatch({
              type: actionType.CR_URA_GRID_DATA,
              payload: data.tabdata,
            });
            makeItDirty();
            cellInfo.api.refreshCells();
          }}
          onBlur={(e) => {
            let data = qtrHandler(
              e.target.value,
              cellInfo,
              true,
              ura_grid_data,
              err_msg,
              'pay',
              'startQtr'
            );
            dispatch({
              type: actionType.CR_URA_GRID_DATA,
              payload: data.tabdata,
            });
            dispatch(createRebateErrorMsg([...new Set([...data.err])]));
            cellInfo.api.refreshCells();
          }}
        />
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        <>
          {cellInfo.column.colId === 'rpcParamValue' && (
            <div className="tbl-checkbox">
              <FormControlLabel
                control={<Checkbox color="primary" />}
                value={cellInfo.data.rpcParamValue == 0 ? false : true || false}
                onChange={(e, val) => {
                  let ind = cellInfo.node.rowIndex;
                  let data = val === true ? 1 : 0;
                  uraChangehandler(data, 'rpcParamValue', ind, 'pay', grid);
                  cellInfo.api.refreshCells();
                }}
                checked={
                  cellInfo.data.rpcParamValue == 0 ? false : true || false
                }
                onKeyDown={(e) => {
                  // if (
                  //   (e.key === 'Tab' && !e.shiftKey) ||
                  //   e.key === 'ArrowRight'
                  // ) {
                  //   uraRecordAdd('pay', grid, err);
                  // }
                }}
              />
            </div>
          )}
          {cellInfo.column.colId === 'delete' && (
            // <div className="tbl-checkbox">
            //   <FormControlLabel
            //     control={<Checkbox color="primary" />}
            //     value={cellInfo.data.delete || false}
            //     onChange={(e, val) => {
            //       let ind = cellInfo.node.rowIndex;
            //       uraChangehandler(val, 'delete', ind, 'pay', grid);
            //       cellInfo.api.refreshCells();
            //     }}
            //     checked={cellInfo.data.delete || false}
            //   />
            // </div>
            <>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
              >
                <Button
                  className="frr-box-shadow-none"
                  data-testid=""
                  aria-label="Add Update URA from Payments"
                  variant="text"
                  onClick={() => uraRecordAdd('pay', grid, err)}
                >
                  <SVGComponent iconName="Icon-addCircle" />{' '}
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Delete</Tooltip>}
              >
                <Button
                  className="th-ic trash-blue frr-box-shadow-none"
                  variant="text"
                  aria-label="Trash"
                  onClick={() => {
                    setDeleteModal(true);
                    setDeleteInd({ table: 'pay', grid: grid, data: cellInfo });
                  }}
                >
                  <SVGComponent iconName="Icon-delete" />
                </Button>
              </OverlayTrigger>
            </>
          )}
        </>
      );
    },
  };
  /* URA Tab Grid : End */

  /* Int Share Tab Grid : Start */
  const int_grid_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
  );
  const cr_copy_int_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_copy_int_data
  );
  const deleted_int_calc = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_int_calc
  );
  const deleted_int_fed = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_int_fed
  );
  const deleted_int_fed_fmly = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_int_fed_fmly
  );

  const intChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    let tabdata = { ...record };
    let grid;
    if (table === 'intcalc') grid = [...record.rpcParamVoIntShareIntCalList];
    if (table === 'intfed') grid = [...record.rpcCalcPctVOIntShareFedaralList];
    if (table === 'intfedfmly')
      grid = [...record.rpcParamVoIntShareFedaralFamiliList];
    let data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'intcalc')
      tabdata.rpcParamVoIntShareIntCalList = data.newdata;
    if (table === 'intfed')
      tabdata.rpcCalcPctVOIntShareFedaralList = data.newdata;
    if (table === 'intfedfmly')
      tabdata.rpcParamVoIntShareFedaralFamiliList = data.newdata;
    if (blur) dispatch(createRebateErrorMsg(data.err));
    dispatch({ type: actionType.CR_INT_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const intCalcFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const pgmDetails = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      const onChange = (e, cellInfo, blur) => {
        intChangehandler(
          e.target.value,
          'calcFixedPct',
          cellInfo.node.rowIndex,
          'intcalc',
          grid,
          blur,
          err_msg
        );
      };

      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled =
        !pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD'
          ? true
          : false;

      return (
        <>
          {cellInfo.column.colId === 'effectiveQtr' && (
            <TextField
              id="effectiveQtr1"
              className={
                cellInfo.data?.effectiveQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputProps={{ id: 'effectiveQtr1' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.effectiveQtr || ''}
              disabled={isDisabled}
              onChange={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intcalc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              onBlur={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intcalc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(createRebateErrorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'calcFixedPct' && (
            <TextField
              id="calcFixedPct5"
              InputProps={{ id: 'calcFixedPct5' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.calcFixedPct}
              className={
                cellInfo.data?.calcFixedPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              disabled={isDisabled || cellInfo.data.calcMethodCd === 'T'}
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intcalc', grid, err_msg, pgmDetails);
                // }
              }}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const pgmDetails = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const int_calc = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.int_calc
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled =
        !pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD'
          ? true
          : false;
      return (
        <TextField
          id="rbtprg1"
          style={{ width: '150px' }}
          InputProps={{ id: 'rbtprg1' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.calcMethodCd || ''}
          select
          className={
            cellInfo.data?.calcMethodCdErr
              ? 'td-active-cell tBill-validate'
              : ''
          }
          onChange={(e) => {
            let i = cellInfo.node.rowIndex;
            let v = e.target.value;
            intChangehandler(v, 'calcMethodCd', i, 'intcalc', grid, true, err);

            if (v === 'T') {
              intChangehandler(
                '',
                'calcFixedPct',
                i,
                'intcalc',
                grid,
                false,
                err
              );
            }
          }}
          disabled={isDisabled}
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1">
            {''}
          </MenuItem>
          {int_calc &&
            int_calc.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      const createPgmDetail = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );
      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled =
        !createPgmDetail?.planTypeCd || createPgmDetail?.planTypeCd === 'FD'
          ? true
          : false;

      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intcalc', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //     disabled={create_pgm_detail?.planTypeCd === 'FD'}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Interest Calculation"
              variant="text"
              disabled={isDisabled}
              onClick={() =>
                intRecordAdd('intcalc', grid, err, createPgmDetail)
              }
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              disabled={isDisabled}
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'intcalc', grid: grid, data: cellInfo });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const intRecordAdd = (table, grid, err, pgmDetail) => {
    let data = grid ? { ...grid } : { ...int_grid_data };
    let error = err ? [...err] : [...create_err_msg];
    if (table === 'intcalc') {
      let newdata = intCalcChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_INT_GRID_DATA,
          payload: { ...data, rpcParamVoIntShareIntCalList: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'intfed') {
      let newdata = intFedaralChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_INT_GRID_DATA,
          payload: {
            ...data,
            rpcCalcPctVOIntShareFedaralList: newdata.newdata,
          },
        });
        return;
      }
    }
    if (table === 'intfedfmly') {
      let newdata = intFedFamilyChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_INT_GRID_DATA,
          payload: {
            ...data,
            rpcParamVoIntShareFedaralFamiliList: newdata.newdata,
          },
        });
        return;
      }
    }
    // let data = { ...int_grid_data };

    const intData = addTableRecord(
      table,
      data,
      pgmDetail?.rebateProgramCd || create_pgm_detail?.rebateProgramCd,
      pgmDetail?.planTypeCd || create_pgm_detail?.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.CR_INT_GRID_DATA, payload: intData });
    makeItDirty();
  };
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    if (
      create_pgm_detail?.planTypeCd === 'FD' &&
      int_grid_data?.rpcParamVoIntShareIntCalList?.length === 0
    ) {
      const intData = addTableRecord(
        'intcalc',
        int_grid_data,
        create_pgm_detail?.rebateProgramCd,
        create_pgm_detail?.planTypeCd,
        logInUser
      );
      dispatch({ type: actionType.CR_INT_GRID_DATA, payload: intData });
      // makeItDirty();
    }
  }, [create_pgm_detail?.planTypeCd, int_grid_data]);

  // const intRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...int_grid_data,
  //   });

  //   if (table === 'intcalc')
  //     dispatch({
  //       type: actionType.CR_DELETED_INT_CALC,
  //       payload: [...deleted_int_calc, ...deletedOld],
  //     });
  //   if (table === 'intfed')
  //     dispatch({
  //       type: actionType.CR_DELETED_INT_FED,
  //       payload: [...deleted_int_fed, ...deletedOld],
  //     });
  //   if (table === 'intfedfmly')
  //     dispatch({
  //       type: actionType.CR_DELETED_INT_FED_FMLY,
  //       payload: [...deleted_int_fed_fmly, ...deletedOld],
  //     });
  //   err = removeErr([...create_err_msg], err);
  //   dispatch(createRebateErrorMsg(err));
  //   dispatch({ type: actionType.CR_INT_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  const intFedaralFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const createPgmDetail = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      const onChange = (e, cellInfo, blur) => {
        let value = e.target.value;
        if (value && value.includes('.')) {
          if (AppConstants.AMOUNT.test(value)) {
            value = e.target.value;
          } else {
            return false;
          }
        } else if (AppConstants.RX_WITHOUT.test(value)) {
          value = e.target.value;
        } else {
          return false;
        }
        if (blur) value = value ? parseFloat(value).toFixed(2) : '';
        intChangehandler(
          value,
          'rpcParamValue',
          cellInfo.node.rowIndex,
          'intfed',
          grid,
          blur,
          err_msg
        );
      };

      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              id="startQrt1"
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputProps={{ id: 'startQrt1' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.startQtr || ''}
              inputProps={{ maxLength:6 }}
              onChange={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intfed',
                  'startQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              onBlur={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intfed',
                  'startQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(createRebateErrorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'rpcParamValue' && (
            <TextField
              id="rpcParamValue1"
              className={
                cellInfo.data?.rpcParamValueErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputProps={{ id: 'rpcParamValue1' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.rpcParamValue}
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intfed', grid, err_msg, createPgmDetail);
                // }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const createPgmDetail = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intfed', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Federal %"
              variant="text"
              onClick={() => intRecordAdd('intfed', grid, err, createPgmDetail)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'intfed', grid: grid, data: cellInfo });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const intFedFamilyFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const createPgmDetail = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      const onChange = (e, cellInfo, blur) => {
        let value = e.target.value;
        if (value && value.includes('.')) {
          if (AppConstants.AMOUNT.test(value)) {
            value = e.target.value;
          } else {
            return false;
          }
        } else if (AppConstants.RX_WITHOUT.test(value)) {
          value = e.target.value;
        } else {
          return false;
        }
        if (blur) value = value ? parseFloat(value).toFixed(2) : '';
        intChangehandler(
          value,
          'rpcParamValue',
          cellInfo.node.rowIndex,
          'intfedfmly',
          grid,
          blur,
          err_msg
        );
      };

      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              id="startQtr7"
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength:6 }}
              InputProps={{ id: 'startQtr7' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.startQtr || ''}
              onChange={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intfedfmly',
                  'startQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              onBlur={(e) => {
                let data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intfedfmly',
                  'startQtr'
                );
                dispatch({
                  type: actionType.CR_INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(createRebateErrorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'rpcParamValue' && (
            <TextField
              id="rpcParamValue8"
              className={
                cellInfo.data?.rpcParamValueErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputProps={{ id: 'rpcParamValue8' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.rpcParamValue}
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intfedfmly', grid, err_msg, createPgmDetail);
                // }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const createPgmDetail = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intfedfmly', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Federal Family Planning %"
              variant="text"
              onClick={() =>
                intRecordAdd('intfedfmly', grid, err, createPgmDetail)
              }
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({
                  table: 'intfedfmly',
                  grid: grid,
                  data: cellInfo,
                });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  /* Int Share Tab Grid : End */

  /* Group Tab Grid : Start */
  const group_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_group_data
  );
  const cr_copy_group_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_copy_group_data
  );
  const deleted_cms_rpt = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_cms_rpt
  );

  const deleted_cms_util = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_cms_util
  );

  const cms_freeze_qtr = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_cms_freeze_qtr
  );

  const groupChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    let tabdata = { ...record };
    let grid;
    if (table === 'cmsrpt') grid = [...record.cmsReporting];
    if (table === 'cmsutil') grid = [...record.cmsUtilization];
    let data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'cmsrpt') tabdata.cmsReporting = data.newdata;
    if (table === 'cmsutil') tabdata.cmsUtilization = data.newdata;
    if (blur) dispatch(createRebateErrorMsg(data.err));
    dispatch({ type: actionType.CR_GROUP_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const cmsReportFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_group_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      const onchange = (e, data, blur) => {
        let obj;
        let val = e.target.value;
        let cid = data.column.colId;
        if (!blur)
          obj = qtrHandler(val, data, false, grid, err_msg, 'cmsrpt', cid);
        else
          obj = qtrHandler(
            val,
            data,
            true,
            grid,
            err_msg,
            'cmsrpt',
            cid,
            true,
            cms_freeze_qtr
          );
        dispatch({
          type: actionType.CR_GROUP_GRID_DATA,
          payload: obj.tabdata,
        });
        if (!blur) makeItDirty();
        else dispatch(createRebateErrorMsg([...new Set([...obj.err])]));
        data.api.refreshCells();
      };

      const fldChange = (e, cellInfo, fld, blur) => {
        let ind = cellInfo.node.rowIndex;
        let val = e.target.value;
        groupChangehandler(val, fld, ind, 'cmsrpt', grid, blur, err_msg);
      };
      let disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              id="startQtr9"
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ id: 'startQtr9', maxLength: 6 }}
              InputLabelProps={{ shrink: true, tabIndex: 0 }}
              value={cellInfo.data.startQtr}
              onChange={(e) => onchange(e, cellInfo, false)}
              onBlur={(e) => onchange(e, cellInfo, true)}
              disabled={disableFld}
            />
          )}
          {cellInfo.column.colId === 'endQtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  CMS reporting group record cannot be updated since the group
                  is used. Please use End quarter instead
                </Tooltip>
              }
            >
              <TextField
                id="endQtr1"
                className={
                  cellInfo.data?.endQtrErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                inputProps={{ id: 'endQtr1', maxLength: 6 }}
                InputLabelProps={{ shrink: true, tabIndex: 0 }}
                value={cellInfo.data.endQtr}
                onChange={(e) => onchange(e, cellInfo, false)}
                onBlur={(e) => onchange(e, cellInfo, true)}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'cmsRptGroupNum' && (
            <TextField
              id="cmsRptGroupNum1"
              InputProps={{ id: 'cmsRptGroupNum1' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsRptGroupNum}
              className={
                cellInfo.data?.cmsRptGroupNumErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength: 2 }}
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptGroupNum', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptGroupNum', true)}
              disabled={disableFld}
            />
          )}
          {cellInfo.column.colId === 'cmsRptGroupName' && (
            <TextField
              id="cmsRptGroupName3"
              inputProps={{ id: 'cmsRptGroupName3', maxLength: 60 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsRptGroupName}
              className={
                cellInfo.data?.cmsRptGroupNameErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptGroupName', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptGroupName', true)}
              disabled={disableFld}
            />
          )}
          {cellInfo.column.colId === 'cmsRptTitle' && (
            <TextField
              id="cmsRptTitle1"
              inputProps={{ id: 'cmsRptTitle1', maxLength: 60 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsRptTitle}
              className={
                cellInfo.data?.cmsRptTitleErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptTitle', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptTitle', true)}
              onKeyDown={(e) => {
                if (
                  ((e.key === 'Tab' && !e.shiftKey) ||
                    e.key === 'ArrowRight') &&
                  grid.cmsReporting.length === cellInfo.rowIndex + 1
                ) {
                  grpRecordAdd('cmsrpt', grid, err_msg);
                }
              }}
              disabled={disableFld}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_group_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      let disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       groupChangehandler(val, 'delete', ind, 'cmsrpt', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => grpRecordAdd('cmsrpt', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableCnd ? (
                <Tooltip>
                  CMS reporting group record cannot be deleted since the group
                  is used. Please use End quarter instead
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'cmsrpt', grid: grid, data: cellInfo });
              }}
              disabled={disableCnd}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const cmsUtilFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_group_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      const onchange = (e, data, blur) => {
        let obj;
        let va = e.target.value;
        let cid = data.column.colId;
        if (!blur)
          obj = qtrHandler(va, data, false, grid, err_msg, 'cmsutil', cid);
        else
          obj = qtrHandler(
            va,
            data,
            true,
            grid,
            err_msg,
            'cmsutil',
            cid,
            true,
            cms_freeze_qtr
          );
        dispatch({
          type: actionType.CR_GROUP_GRID_DATA,
          payload: obj.tabdata,
        });
        if (!blur) makeItDirty();
        else dispatch(createRebateErrorMsg([...new Set([...obj.err])]));
        data.api.refreshCells();
      };
      const fldChange = (e, cellInfo, fld, blur) => {
        let ind = cellInfo.node.rowIndex;
        let val = e.target.value;
        groupChangehandler(val, fld, ind, 'cmsutil', grid, blur, err_msg);
      };
      let disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              id="startQtr01"
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ id: 'startQtr01', maxLength: 6 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.startQtr}
              onChange={(e) => onchange(e, cellInfo, false)}
              onBlur={(e) => onchange(e, cellInfo, true)}
              disabled={disableFld}
            />
          )}
          {cellInfo.column.colId === 'endQtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  CMS Utilization group record cannot be updated since the group
                  is used. Please use End quarter instead
                </Tooltip>
              }
            >
              <TextField
                id="endQtr02"
                className={
                  cellInfo.data?.endQtrErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                inputProps={{ id: 'endQtr02', maxLength: 6 }}
                InputLabelProps={{ shrink: true }}
                value={cellInfo.data.endQtr}
                onChange={(e) => onchange(e, cellInfo, false)}
                onBlur={(e) => onchange(e, cellInfo, true)}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'cmsUtilGroupNum' && (
            <TextField
              id="cmsUtilGroupNum01"
              InputProps={{ id: 'cmsUtilGroupNum01' }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsUtilGroupNum}
              className={
                cellInfo.data?.cmsUtilGroupNumErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength: 2 }}
              onChange={(e) => fldChange(e, cellInfo, 'cmsUtilGroupNum', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsUtilGroupNum', true)}
              disabled={disableFld}
            />
          )}
          {cellInfo.column.colId === 'cmsUtilGroupName' && (
            <TextField
              id="cmsUtilGroupName03"
              inputProps={{ id: 'cmsUtilGroupName03', maxLength: 60 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsUtilGroupName}
              className={
                cellInfo.data?.cmsUtilGroupNameErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) =>
                fldChange(e, cellInfo, 'cmsUtilGroupName', false)
              }
              onBlur={(e) => fldChange(e, cellInfo, 'cmsUtilGroupName', true)}
              disabled={disableFld}
              onKeyDown={(e) => {
                if (
                  ((e.key === 'Tab' && !e.shiftKey) ||
                    e.key === 'ArrowRight') &&
                  grid.cmsUtilization.length === cellInfo.rowIndex + 1
                ) {
                  grpRecordAdd('cmsutil', grid, err_msg);
                }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_group_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      let disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       groupChangehandler(val, 'delete', ind, 'cmsutil', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => grpRecordAdd('cmsutil', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableCnd ? (
                <Tooltip>
                  CMS Utilization group record cannot be deleted since the group
                  is used. Please use End quarter instead
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <span>
              <Button
                className="th-ic trash-blue frr-box-shadow-none"
                variant="text"
                aria-label="Trash"
                data-test="deletePopup"
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteInd({
                    table: 'cmsutil',
                    grid: grid,
                    data: cellInfo,
                  });
                }}
                disabled={disableCnd}
              >
                <SVGComponent iconName="Icon-delete" />
              </Button>
            </span>
          </OverlayTrigger>
        </>
      );
    },
  };

  const grpRecordAdd = (table, grid, err) => {
    let data = grid ? { ...grid } : { ...group_data };
    let error = err ? [...err] : [...create_err_msg];
    if (table === 'cmsrpt') {
      let newdata = cmsReportingChk(data, cms_freeze_qtr);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_GROUP_GRID_DATA,
          payload: { ...data, cmsReporting: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'cmsutil') {
      let newdata = cmsUtilizationChk(data, cms_freeze_qtr);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.CR_GROUP_GRID_DATA,
          payload: { ...data, cmsUtilization: newdata.newdata },
        });
        return;
      }
    }
    // let data = { ...group_data };
    let grpData = addTableRecord(
      table,
      data,
      create_pgm_detail.rebateProgramCd,
      create_pgm_detail.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.CR_GROUP_GRID_DATA, payload: grpData });
    makeItDirty();
  };

  // const grpRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...group_data,
  //   });
  //   if (table === 'cmsrpt')
  //     dispatch({
  //       type: actionType.CR_DELETED_CMS_RPT,
  //       payload: [...deleted_cms_rpt, ...deletedOld],
  //     });
  //   if (table === 'cmsutil')
  //     dispatch({
  //       type: actionType.CR_DELETED_CMS_UTIL,
  //       payload: [...deleted_cms_util, ...deletedOld],
  //     });
  //   err = removeErr([...create_err_msg], err);
  //   dispatch(createRebateErrorMsg(err));
  //   dispatch({ type: actionType.CR_GROUP_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  /* Group Tab Grid : End */

  /* Enrollment Tab Grid : Start */
  const enroll_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_enroll_data
  );
  const copy_enroll_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_copy_enroll_data
  );

  const deleted_enroll = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_deleted_enroll
  );

  const enrollChangehandler = (val, prop, indx, record, error) => {
    let tabdata = [...record];
    let newdata = tabdata?.map((obj, ind) => {
      if (indx === ind) {
        let msg = `${Messages.ENROLL_TIMING_ERR} ${ind + 1}`;
        obj[prop] = val;
        if (prop === 'enrollmentTimingCd') {
          let err = [...error];
          if (!val || val === '-1') {
            obj.timingcdErr = true;
            obj.timingcdMsg = msg;
            err = [...error, msg];
          } else {
            err = removeErr(err, [msg]);
            obj.timingcdErr = false;
            obj.timingcdMsg = '';
          }
          dispatch(createRebateErrorMsg(err));
        }
      }
      return obj;
    });
    dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: newdata });
    makeItDirty();
  };

  const commentsData = (status, table, corrLinkId) => {
    setShowComments(status);
    setLinkTable(table);
    setCorrLinkId(corrLinkId);
  };

  const max_enroll_qtr = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_max_enroll_qtr
  );

  const enrollFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      const mx = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_max_enroll_qtr
      );
      let disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      return (
        <>
          {cellInfo.column.colId === 'qtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  Enrollment record cannot be updated since the enrollment
                  record is used
                </Tooltip>
              }
            >
              <TextField
                id="qtrData01"
                className={
                  cellInfo.data?.qtrErr ? 'td-active-cell tBill-validate' : ''
                }
                InputProps={{ id: 'qtrData01' }}
                InputLabelProps={{ shrink: true }}
                value={cellInfo.data.qtr || ''}
                disabled={disableFld}
                onChange={(e) => {
                  let val = e.target.value;
                  let da = cellInfo;
                  let data = qtrHandler(
                    val,
                    da,
                    false,
                    grid,
                    err,
                    'roll',
                    'qtr'
                  );
                  dispatch({
                    type: actionType.CR_ENROLL_GRID_DATA,
                    payload: data.tabdata,
                  });
                  makeItDirty();
                  cellInfo.api.refreshCells();
                }}
                onBlur={(e) => {
                  let v = e.target.value;
                  let d = cellInfo;
                  let data = qtrHandler(
                    v,
                    d,
                    true,
                    grid,
                    err,
                    'roll',
                    'qtr',
                    mx
                  );
                  dispatch({
                    type: actionType.CR_ENROLL_GRID_DATA,
                    payload: data.tabdata,
                  });
                  dispatch(createRebateErrorMsg([...new Set([...data.err])]));
                  cellInfo.api.refreshCells();
                }}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'numOfLives' && (
            <TextField
              id="numOfLives01"
              inputProps={{
                maxLength: 15,
                id: 'numOfLives01',
              }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.numOfLives}
              onChange={(e) => {
                let ind = cellInfo.node.rowIndex;
                let value = e.target.value;
                enrollChangehandler(value, 'numOfLives', ind, grid);
                cellInfo.api.refreshCells();
              }}
              disabled={disableFld}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const enroll_time = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.enroll_time
      );
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );

      return (
        <TextField
          id="enrollmentTimingCd01"
          style={{ width: '150px' }}
          className={
            cellInfo.data?.timingcdErr ? 'td-active-cell tBill-validate' : ''
          }
          InputProps={{ id: 'enrollmentTimingCd01' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.enrollmentTimingCd || ''}
          select
          onChange={(e) => {
            let ind = cellInfo.node.rowIndex;
            let value = e.target.value;
            enrollChangehandler(value, 'enrollmentTimingCd', ind, grid, err);
            cellInfo.api.refreshCells();
          }}
          disabled={
            !cellInfo.data.newFlag &&
            cellInfo.data.qtr &&
            !cellInfo.data.qtrErr &&
            max_enroll_qtr &&
            !compareQtrs(cellInfo.data.qtr, max_enroll_qtr)
          }
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1">
            {''}
          </MenuItem>
          {enroll_time &&
            enroll_time.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      let disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       enrollChangehandler(val, 'delete', ind, grid);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid="enrollRecordAdd"
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => enrollRecordAdd(grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableCnd ? (
                <Tooltip>
                  Enrollment record cannot be deleted since the enrollment
                  record is used
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'enroll', grid: grid, data: cellInfo });
              }}
              disabled={disableCnd}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
    CommentsRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      let disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      return (
        <div className="tdCell frr-icon-btn-group d-flex justify-content-start">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
          >
            {!cellInfo.data.newFlag ? (
              <Button
                onClick={() =>
                  commentsData(true, 'RPC_ENROLLMENT', cellInfo.data.corrLinkID)
                }
                variant="text"
                disabled={disableCnd}
                onKeyDown={(e) => {
                  // if (
                  //   (e.key === 'Tab' && !e.shiftKey) ||
                  //   e.key === 'ArrowRight'
                  // ) {
                  //   enrollRecordAdd(grid, err);
                  // }
                }}
              >
                <img
                  alt="comment"
                  src={
                    cellInfo.data.cc_COMMENTS_EXIST
                      ? CommentVisibleIcon
                      : CommentIcon
                  }
                />
              </Button>
            ) : (
              <Button
                disabled
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn"
                variant="text"
              >
                <img alt="comment" src={CommentIcon} />
              </Button>
            )}
          </OverlayTrigger>
        </div>
      );
    },
  };

  // const enrollRecordDelete = () => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord('roll', [
  //     ...enroll_data,
  //   ]);
  //   dispatch({
  //     type: actionType.CR_DELETED_ENROLL,
  //     payload: [...deleted_enroll, ...deletedOld],
  //   });
  //   err = removeErr([...create_err_msg], err);
  //   dispatch(createRebateErrorMsg(err));
  //   dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  const enrollRecordAdd = (grid, err) => {
    let data = grid ? [...grid] : [...enroll_data];
    let error = err ? [...err] : [...create_err_msg];
    let newData = enrollTabValidation(data, max_enroll_qtr);
    if (newData.err.length) {
      dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: newData.rec });
      addFnErrHandler(newData.err, error);
      return;
    }
    let grpData = addTableRecord(
      'roll',
      data,
      create_pgm_detail.rebateProgramCd,
      create_pgm_detail.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: grpData });
    makeItDirty();
  };

  const gridParamsSet = (params) => {
    setEnrollParams(params);
  };
  /* Enrollment Tab Grid : End */

  /* Audits Tab : Start */
  const default_audit = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_default_audit
  );
  const audit_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_audit_data
  );
  const copy_audit_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_copy_audit_data
  );
  const auditchangeHandler = (val, fld, check = false) => {
    let data = { ...audit_data };
    data[fld] = check ? (val === true ? 1 : 0) : val;
    dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: data });
    makeItDirty();
  };
  /* Audits Tab : End */

  /* Unit Type Audit Tab : Start */
  const copy_unit_type_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_copy_unit_type_data
  );
  const unit_type_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_unit_type_data
  );
  const unitTypeChangehandler = (val, prop, data, record, blur, err = []) => {
    let error;
    let list = [...err];
    let indx = data.node.rowIndex;
    if (val === '' || !val)
      error =
        prop === 'testAmt'
          ? `${Messages.THRESHOLD_UNIT_ERR} ${indx + 1}`
          : `${Messages.MAIL_ORDER_ERR} ${indx + 1}`;
    if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(val))
      error =
        prop === 'testAmt'
          ? `${Messages.THRESHOLD_UNIT_NUM_ERR} in Row ${indx + 1}`
          : `${Messages.MAIL_ORDER_NUM_ERR} in Row ${indx + 1}`;
    let newdata = record?.map((obj, ind) => {
      if (indx === ind) {
        if (blur) {
          if (error) {
            obj[`${prop}Err`] = true;
            obj[`${prop}Msg`] = error;
            list = [...new Set([...err, error])];
          } else {
            list = removeErr(err, [obj[`${prop}Msg`]]);
            obj[`${prop}Err`] = false;
            obj[`${prop}Msg`] = '';
          }
        }
        if (prop === 'testOnInd' && !val) {
          let er = removeErr(err, [
            data.data.testAmtMsg,
            data.data.mailOrderMultiplierMsg,
          ]);
          dispatch(createRebateErrorMsg(er));
          obj.testAmtErr = false;
          obj.mailOrderMultiplierErr = false;
        }
        obj[prop] = val;
      }
      return obj;
    });
    dispatch({
      type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
      payload: newdata,
    });
    if (blur) dispatch(createRebateErrorMsg(list));
    makeItDirty();
  };
  const unitTypeFrameworkComponent = {
    TextBoxRenderer: (cellInfo) => {
      const pgmDetails = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_unit_type_data
      );
      const default_audit = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_default_audit
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      const onchange = (e, prop, data, blur) => {
        let val = e.target.value;
        unitTypeChangehandler(val, prop, data, grid, blur, err);
      };
      return (
        <>
          {cellInfo.column.colId === 'testAmt' && (
            <TextField
              id="testAmt03"
              InputProps={{
                id: 'testAmt03',
                inputComponent: NumberFormatCustom,
                inputProps: {
                  isAllowed: ({ floatValue }) =>
                    floatValue === undefined || /^\d{0,7}(\.\d{0,2})?$/.test(floatValue.toString())
                }
              }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.testAmt || ''}
              className={
                cellInfo.data?.testAmtErr ? 'td-active-cell tBill-validate' : ''
              }
              disabled={
                !cellInfo.data.testOnInd ||
                default_audit ||
                pgmDetails?.planTypeCd === 'SUPP'
              }
              onChange={(e) => {
                // let val = e.target.value;
                // unitTypeChangehandler(val, 'testAmt', cellInfo, grid);
                // makeItDirty();
                // cellInfo.api.refreshCells();
                onchange(e, 'testAmt', cellInfo, false);
              }}
              onBlur={(e) => {
                onchange(e, 'testAmt', cellInfo, true);
                // if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(e.target.value)) {
                //   setErrorMessage(Messages.THRESHOLD_UNIT_NUM_ERR);
                //   setErrorPopup(true);
                // }
              }}
            />
          )}
          {cellInfo.column.colId === 'mailOrderMultiplier' && (
            <TextField
              id="mailOrderMultiplier01"
              InputProps={{
                id: 'mailOrderMultiplier01',
                inputComponent: NumberFormatCustomSix,
                inputProps: {
                  isAllowed: ({ floatValue }) =>
                    floatValue === undefined || /^\d{0,5}(\.\d{0,6})?$/.test(floatValue.toString())
                }
              }}
              InputLabelProps={{ shrink: true }}
              className={
                cellInfo.data?.mailOrderMultiplierErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              value={cellInfo.data.mailOrderMultiplier}
              disabled={
                !cellInfo.data.testOnInd ||
                default_audit ||
                pgmDetails?.planTypeCd === 'SUPP'
              }
              onChange={(e) => {
                onchange(e, 'mailOrderMultiplier', cellInfo, false);
                // let l = e.target.value;
                // unitTypeChangehandler(l, 'mailOrderMultiplier', cellInfo, grid);
                // makeItDirty();
              }}
              onBlur={(e) => {
                onchange(e, 'mailOrderMultiplier', cellInfo, true);
                // if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(e.target.value)) {
                //   setErrorMessage(Messages.MAIL_ORDER_NUM_ERR);
                //   setErrorPopup(true);
                // }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const pgmDetails = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_pgm_detail
      );

      const grid = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_unit_type_data
      );
      const default_audit = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.cr_default_audit
      );
      const err = useSelector(
        (state) => state?.sharedState?.CreateRebateReducer?.create_err_msg
      );
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            disabled={default_audit || pgmDetails?.planTypeCd === 'SUPP'}
            value={cellInfo.data.testOnInd === 1 ? true : false}
            onChange={(e, val) => {
              let value = val == true ? 1 : 0;
              unitTypeChangehandler(
                value,
                'testOnInd',
                cellInfo,
                grid,
                false,
                err
              );
            }}
            checked={cellInfo.data.testOnInd === 1 ? true : false}
          />
        </div>
      );
    },
  };
  /* Unit Type Audit Tab : End */

  /* Other Common Functions : Start */
  const comment_flag = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_comment_flag
  );
  const created_flag = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.created_flag
  );

  const use_def_audit = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_use_def_audit
  );

  const def_override = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_def_override
  );

  const is_valid_rebate_pgm = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.is_valid_rebate_pgm
  );

  const audit_grid_data = useSelector(
    (state) => state?.sharedState?.CreateRebateReducer?.cr_audit_grid_data
  );

  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState([]);
  const [tabFullSrn, setTabFullSrn] = React.useState(false);

  const deleteFromTable = () => {
    setDeleteModal(false);
    const indx = deleteInd.data.node.rowIndex;
    let err = [...create_err_msg];
    let deletedOld = !deleteInd.data.data.newFlag;
    if (deleteInd.table === 'src') {
      const rec = deleteInd.grid.rpcUraSource.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_URA_SOURCE,
          payload: [...CR_deleted_ura_src, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [deleteInd.data.data.startQtrMsg]);
      if (rec.length === 0) {
        let calcOld = deleteInd.grid.rpcUraCal.filter((o) => !o.newFlag);
        let cerr = [
          ...deleteInd.grid.rpcUraCal.map((o) => o.effectiveQtrMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcMethodCdMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcGenericPctMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcFixedPctMsg),
        ];
        err = removeErr(err, cerr);
        dispatch(createRebateErrorMsg(err));
        dispatch({
          type: actionType.CR_DELETED_URA_CALC,
          payload: [...cr_deleted_ura_calc, ...calcOld],
        });
        dispatch({
          type: actionType.CR_URA_GRID_DATA,
          payload: { ...deleteInd.grid, rpcUraSource: rec, rpcUraCal: [] },
        });
        return;
      }
      dispatch({
        type: actionType.CR_URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUraSource: rec },
      });
    }
    if (deleteInd.table === 'calc') {
      const rec = deleteInd.grid.rpcUraCal.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_URA_CALC,
          payload: [...cr_deleted_ura_calc, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.effectiveQtrMsg,
        deleteInd.data.data.calcMethodCdMsg,
        deleteInd.data.data.calcGenericPctMsg,
        deleteInd.data.data.calcFixedPctMsg,
      ]);
      dispatch({
        type: actionType.CR_URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUraCal: rec },
      });
    }
    if (deleteInd.table === 'pay') {
      const rec = deleteInd.grid.rpcUrPayment.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_URA_PAY,
          payload: [...CR_deleted_ura_pay, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [deleteInd.data.data.startQtrMsg]);
      dispatch({
        type: actionType.CR_URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUrPayment: rec },
      });
    }
    if (deleteInd.table === 'intcalc') {
      const rec = deleteInd.grid.rpcParamVoIntShareIntCalList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_INT_CALC,
          payload: [...deleted_int_calc, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.effectiveQtrMsg,
        deleteInd.data.data.calcMethodCdMsg,
        deleteInd.data.data.calcFixedPctMsg,
      ]);
      dispatch({
        type: actionType.CR_INT_GRID_DATA,
        payload: { ...deleteInd.grid, rpcParamVoIntShareIntCalList: rec },
      });
    }
    if (deleteInd.table === 'intfed') {
      const rec = deleteInd.grid.rpcCalcPctVOIntShareFedaralList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_INT_FED,
          payload: [...deleted_int_fed, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.rpcParamValueMsg,
      ]);
      dispatch({
        type: actionType.CR_INT_GRID_DATA,
        payload: { ...deleteInd.grid, rpcCalcPctVOIntShareFedaralList: rec },
      });
    }
    if (deleteInd.table === 'intfedfmly') {
      const rec = deleteInd.grid.rpcParamVoIntShareFedaralFamiliList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_INT_FED_FMLY,
          payload: [...deleted_int_fed_fmly, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.rpcParamValueMsg,
      ]);
      dispatch({
        type: actionType.CR_INT_GRID_DATA,
        payload: {
          ...deleteInd.grid,
          rpcParamVoIntShareFedaralFamiliList: rec,
        },
      });
    }
    if (deleteInd.table === 'cmsrpt') {
      const rec = deleteInd.grid.cmsReporting.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_CMS_RPT,
          payload: [...deleted_cms_rpt, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.endQtrMsg,
        deleteInd.data.data.cmsRptGroupNumMsg,
        deleteInd.data.data.cmsRptGroupNameMsg,
        deleteInd.data.data.cmsRptTitleMsg,
      ]);
      dispatch({
        type: actionType.CR_GROUP_GRID_DATA,
        payload: { ...deleteInd.grid, cmsReporting: rec },
      });
    }
    if (deleteInd.table === 'cmsutil') {
      const rec = deleteInd.grid.cmsUtilization.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_CMS_UTIL,
          payload: [...deleted_cms_util, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.endQtrMsg,
        deleteInd.data.data.cmsUtilGroupNumMsg,
        deleteInd.data.data.cmsUtilGroupNameMsg,
      ]);
      dispatch({
        type: actionType.CR_GROUP_GRID_DATA,
        payload: { ...deleteInd.grid, cmsUtilization: rec },
      });
    }
    if (deleteInd.table === 'enroll') {
      const rec = deleteInd.grid.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.CR_DELETED_ENROLL,
          payload: [...deleted_enroll, deleteInd.data.data],
        });
      err = removeErr(create_err_msg, [
        deleteInd.data.data.qtrMsg,
        deleteInd.data.data.timingcdMsg,
      ]);
      dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: rec });
    }
    dispatch(createRebateErrorMsg(err));
    setDeleteInd();
    makeItDirty();
  };

  const changeHandler = (val, fld, check = false) => {
   // setSaveMsg([]);
    let data = { ...create_pgm_detail };
    if (!data?.planTypeCd) {
      data['planTypeCd'] = plan_type;
    }
    data[fld] = check ? (val === true ? 1 : 0) : val;

    if (fld === 'claimRebateProgramCd' && data.planTypeCd === 'SUPP') {
      dispatch(getUseDefAuditsInd(val));
      // dispatch(getAuditGridList(val));
      // dispatch(getUnitTypeAuditGridList(val));
    }

    if (fld === 'useDefSystemInd' && !created_flag)
      data = mergeSysDefOverrides(data, data[fld], sys_override, {});
    else if (fld === 'useDefSystemInd' && created_flag)
      data = mergeSysDefOverrides(data, data[fld], sys_override, def_override);
    dispatch(createRebatePgmDetail(data));
    makeItDirty();
  };

  const blurHandler = (val, fld, extraCondition = '') => {
    setSaveMsg([]);
    const { error, flderror, auditFldBlur } = fieldValidation(
      val,
      fld,
      create_err_msg,
      create_fld_err,
      extraCondition
    );
    dispatch(createRebateErrorMsg(error));
    dispatch(createFieldErr(flderror));
    if (auditFldBlur) auditchangeHandler(parseFloat(val).toFixed(2), fld);

    if (
      fld === 'firstSummaryRptQtr' &&
      flderror?.firstSummaryRptQtrErr === false &&
      flderror?.firstSummaryRptQtrReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'firstSummaryRptQtr');
    }

    if (
      fld === 'lastQtrWithoutClaims' &&
      flderror?.lastQtrWithoutClaimsErr === false &&
      flderror?.lastQtrWithoutClaimsReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'lastQtrWithoutClaims');
    }

    if (
      fld === 'dramsInvoiceStartQtr' &&
      flderror?.dramsInvoiceStartQtrErr === false &&
      flderror?.dramsInvoiceStartQtrReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'dramsInvoiceStartQtr');
    }

    if (
      fld === 'defEarliestQtrForDrugDtls' &&
      flderror?.earlierQtrReqErr === false &&
      flderror?.earlierQtrQtrErr === false
    ) {
      changeHandler(val.toUpperCase(), 'defEarliestQtrForDrugDtls');
    }
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const createRebateProgramPayload = () => {
    let data = { ...create_pgm_detail };
    if (!created_flag && data.planTypeCd !== 'SUPP') {
      data.claimRebateProgramCd = data.rebateProgramCd;
    }
    const pgmDetailsPayloadData = pgmDetailsPayload(data, logInUser);
    const URAPayloadData = URAPayload(
      create_ura_grid_data,
      CR_deleted_ura_src,
      cr_deleted_ura_calc,
      CR_deleted_ura_pay,
      create_pgm_detail.rebateProgramCd,
      logInUser
    );
    const IntSharePayloadData = IntSharePayload(
      int_grid_data,
      deleted_int_calc,
      deleted_int_fed,
      deleted_int_fed_fmly,
      create_pgm_detail.rebateProgramCd,
      create_pgm_detail.planTypeCd,
      logInUser
    );

    const GroupPayloadData = GroupPayload(
      group_data,
      deleted_cms_rpt,
      deleted_cms_util,
      create_pgm_detail.rebateProgramCd,
      logInUser
    );
    let EnrollmentPayloadData = { rpcEnrollmentVOList: [] };
    if (
      create_pgm_detail.planTypeCd === 'SUPP' ||
      create_pgm_detail.planTypeCd === 'COMM'
    )
      EnrollmentPayloadData = EnrollmentPayload(
        enroll_data,
        deleted_enroll,
        create_pgm_detail.rebateProgramCd,
        logInUser
      );

    const AuditPayloadData = getAuditPayload(
      audit_data,
      create_pgm_detail.rebateProgramCd,
      logInUser
    );
    const UnitTypeAuditPayloadData = getUnitAuditPayload(
      unit_type_data,
      create_pgm_detail.rebateProgramCd,
      logInUser
    );

    const payloadData = {
      ...pgmDetailsPayloadData,
      ...AuditPayloadData,
      ...URAPayloadData,
      ...IntSharePayloadData,
      ...UnitTypeAuditPayloadData,
      ...GroupPayloadData,
      ...EnrollmentPayloadData,
    };
    return payloadData;
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      REBATE_PROGRAM_CD: create_pgm_detail.rebateProgramCd,
      STUB_INV_SEQ_NUM: 0,
      USE_MCO_SERVICE_DT_IND: 0,
    });
  };

  const clearRebateDetails = () => {
    setSaveMsg([]);
    setCancelView(false);
    // ========================================================================
    dispatch(tabValue('one'));
    dispatch(saveEnable(true));
    dispatch(createRebateErrorMsg([]));
    dispatch(createFieldErr([]));

    // ========================================================================

    if (!created_flag) {
      dispatch({ type: actionType.RESET_CREATE_PGM });
      // ========================================================================
      
      dispatch(
        createRebatePgmDetail({
          planTypeCd: plan_type,
          adjustmentQtrCd: plan_type === 'FD' ? 'P' : '',
          rebateUnitTypeCd: plan_type === 'ST' || plan_type === 'COMM' ? 'UTIL' : '-1',
          rebateProgramCd: '',
          claimRebateProgramCd: ''
        })
      );

      dispatch({ 
        type: actionType.CR_URA_GRID_DATA, 
        payload: { rpcUraSource: [], rpcUraCal: [], rpcUrPayment: [] }
      });
      
      dispatch({ 
        type: actionType.CR_GROUP_GRID_DATA, 
        payload: { cmsReporting: [], cmsUtilization: [] }
      });
      
      dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: [] });
      dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: [] });
      dispatch({ type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA, payload: [] });

      dispatch({ type: actionType.CR_DELETED_CMS_UTIL, payload: [] });
      dispatch({ type: actionType.CR_DELETED_CMS_RPT, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_FED_FMLY, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_FED, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_CALC, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_PAY, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_CALC, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_SOURCE, payload: [] });
      // ========================================================================

    } else {
      // Set copy data
      dispatch(createRebatePgmDetail(JSON.parse(copy_create_pgm_detail)));
      dispatch({
        type: actionType.CR_URA_GRID_DATA,
        payload: JSON.parse(copy_ura_grid_data),
      });
      dispatch({
        type: actionType.CR_INT_GRID_DATA,
        payload: JSON.parse(cr_copy_int_data),
      });
      dispatch({
        type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
        payload: JSON.parse(copy_unit_type_data),
      });
      dispatch({
        type: actionType.CR_GROUP_GRID_DATA,
        payload: JSON.parse(cr_copy_group_data),
      });
      dispatch({
        type: actionType.CR_CONS_AUDIT_DATA,
        payload: JSON.parse(copy_audit_data),
      });
      if (
        create_pgm_detail.planTypeCd === 'SUPP' ||
        create_pgm_detail.planTypeCd === 'COMM'
      ) {
        dispatch({
          type: actionType.CR_ENROLL_GRID_DATA,
          payload: JSON.parse(copy_enroll_data),
        });
      }

      dispatch({ type: actionType.CR_DELETED_CMS_UTIL, payload: [] });
      dispatch({ type: actionType.CR_DELETED_CMS_RPT, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_FED_FMLY, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_FED, payload: [] });
      dispatch({ type: actionType.CR_DELETED_INT_CALC, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_PAY, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_CALC, payload: [] });
      dispatch({ type: actionType.CR_DELETED_URA_SOURCE, payload: [] });
    }
  };

  const saveValidation = () => {
    let errors = [];
    let fld = {};
    let pgm = detailsInvoiceOverrideTabsValidations(
      create_pgm_detail,
      is_valid_rebate_pgm
    );
    if (pgm.error.length > 0) {
      errors = [...errors, ...pgm.error];
      fld = { ...fld, ...pgm.flderror };
      dispatch(createFieldErr(pgm.flderror));
    }
    let ura = uraTabValidation(create_ura_grid_data, last_frozen_qtr);
    if (ura.err.length > 0) {
      errors = [...errors, ...ura.err];
      dispatch({ type: actionType.CR_URA_GRID_DATA, payload: ura.rec });
    }
    let int = intTabValidation(int_grid_data, create_pgm_detail.planTypeCd);
    if (int.err.length > 0) {
      errors = [...errors, ...int.err];
      dispatch({ type: actionType.CR_INT_GRID_DATA, payload: int.rec });
    }
    let group = groupTabValidation(group_data, cms_freeze_qtr);
    if (group.err.length > 0) {
      errors = [...errors, ...group.err];
      dispatch({ type: actionType.CR_GROUP_GRID_DATA, payload: group.rec });
    }
    if (
      create_pgm_detail.planTypeCd === 'SUPP' ||
      create_pgm_detail.planTypeCd === 'COMM'
    ) {
      let enroll = enrollTabValidation(enroll_data, max_enroll_qtr);
      if (enroll.err.length > 0) {
        errors = [...errors, ...enroll.err];
        dispatch({ type: actionType.CR_ENROLL_GRID_DATA, payload: enroll.rec });
      }
    }
    let uniterr = unitTypeTabValidation(unit_type_data);
    if (uniterr.err.length > 0) {
      errors = [...errors, ...uniterr.err];
      dispatch({
        type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
        payload: uniterr.rec,
      });
    }
    let auditerr = auditTabValidation(audit_data);
    if (auditerr.err.length) {
      errors = [...errors, ...auditerr.err];
      // fld = { ...fld, ...auditerr.flderr };
      dispatch(createFieldErr(auditerr.flderr));
    }

    if (errors.length > 0) {
      dispatch(createRebateErrorMsg(errors));
      return false;
    } else return true;
  };

  const saveRebateDetails = (ev, close) => {
    setLoad(true);
    setSaveView(false);

    // API Call
    // CREATE_REBATE_PROGRAM
    const createRebateResponse = createRebateProgramApi(
      createRebateProgramPayload()
    );

    createRebateResponse.then(async (res) => {
      setLoad(false);
      if (res) {
        dispatch(createRebateErrorMsg([]));
        setSaveMsg([SUCCESSMESSAGE_GENERIC]);
        // setTimeout(() => {
        //   setSaveMsg([]);
        // }, 5000);
        if (created_flag) {
          let updatePayload = {
            ...uraPmryPayload(
              create_ura_grid_data,
              copy_ura_grid_data,
              create_pgm_detail.rebateProgramCd,
              logInUser
            ),
            ...intPmryPayload(
              int_grid_data,
              cr_copy_int_data,
              create_pgm_detail.rebateProgramCd,
              logInUser
            ),
            ...grpPmryPayload(
              group_data,
              cr_copy_group_data,
              create_pgm_detail.rebateProgramCd,
              logInUser
            ),
          };
          if (create_pgm_detail.planTypeCd === 'SUPP') {
            updatePayload = {
              ...updatePayload,
              ...enrollPmryPayload(
                enroll_data,
                copy_enroll_data,
                create_pgm_detail.rebateProgramCd,
                logInUser
              ),
            };
          }
          await dispatch(saveUpdateRebatePgm(updatePayload));
        }
        if (close) closeTab(Messages.CREATE_NEW, history);

        dispatch({
          type: actionType.CREATED_FLAG,
          payload: true,
        });

        // Create copy stores
        dispatch({
          type: actionType.COPY_CREATE_REBATE_PGM_DETAIL,
          payload: JSON.stringify({ ...create_pgm_detail }),
        });
        dispatch({
          type: actionType.CR_COPY_UNIT_TYPE_DATA,
          payload: JSON.stringify([...unit_type_data]),
        });
        dispatch({
          type: actionType.CR_COPY_AUDIT_GRID_DATA,
          payload: JSON.stringify({ ...audit_data }),
        });
        dispatch({
          type: actionType.CR_COPY_URA_GRID_DATA,
          payload: JSON.stringify({ ...create_ura_grid_data }),
        });
        dispatch({
          type: actionType.CR_COPY_INT_GRID_DATA,
          payload: JSON.stringify({ ...int_grid_data }),
        });
        dispatch({
          type: actionType.CR_COPY_GROUP_GRID_DATA,
          payload: JSON.stringify({ ...group_data }),
        });
        dispatch({
          type: actionType.CR_COPY_ENROLL_GRID_DATA,
          payload: JSON.stringify([...enroll_data]),
        });

        // Get API's
        if (
          create_pgm_detail.planTypeCd === 'SUPP' ||
          create_pgm_detail.planTypeCd === 'COMM'
        ) {
          dispatch(getEnrollGridData(create_pgm_detail.rebateProgramCd));
          dispatch(getMaxQtrEnroll(create_pgm_detail.rebateProgramCd));

          if (create_pgm_detail.claimRebateProgramCode)
            dispatch(
              getUseDefAuditsInd(create_pgm_detail.claimRebateProgramCode)
            );
        } else {
          dispatch(getClaimCodeList());
          changeHandler(
            create_pgm_detail?.rebateProgramCd,
            'claimRebateProgramCd'
          );
        }

        dispatch(getCmsFreezeQtr(create_pgm_detail.rebateProgramCd));
        dispatch(getLastFrozenQtr(create_pgm_detail.rebateProgramCd));

        dispatch(
          getRebatePgmDetail({
            planType: create_pgm_detail.planTypeCd,
            rebateProg: create_pgm_detail.rebateProgramCd,
          })
        );

        const payload = {
          planTypeCd: create_pgm_detail.planTypeCd,
          rebateProgramCd: create_pgm_detail.rebateProgramCd,
        };
        dispatch(getOverrideDefaultData(payload));

        makeFormDirty(Messages.CREATE_NEW, false);
        dispatch(saveEnable(true));
      } else {
        dispatch(createRebateErrorMsg([FAILED_MESSAGE_GENERIC]));
        setSaveMsg([]);
      }
    });
  };

  /* Other Common Functions : End */
  const sys_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.sys_override
  );
  const def_sys_aud = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.def_sys_aud
  );
  const unit_type = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.unit_type
  );

  React.useEffect(() => {
    if (!plan_list) dispatch(getPlanTypes());

    if (localStorage.getItem('createpgmdetails')) {
      dispatch(tabValue('one'));
      dispatch({
        type: actionType.CUSTOME_RESET_CREATE_PGM,
        payload: {
          create_pgm_detail: {
            planTypeCd: plan_type,
            adjustmentQtrCd: plan_type === 'FD' ? 'P' : '',
            rebateUnitTypeCd:
              plan_type === 'ST' || plan_type === 'COMM' ? 'UTIL' : '-1',
          },
        },
      });

      setCmsRptErr(false);
      setCmsUtilErr(false);
      setEnrollErr(false);

      if (!sys_override) dispatch(getOverrideSystemData({}));

      localStorage.removeItem('createpgmdetails');
    }
    setLoad(false);
  }, []);

  React.useEffect(() => {
    if (plan_list) {
      const planList = plan_list.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name == 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [plan_list]);

  React.useEffect(() => {
    if (use_def_audit && create_pgm_detail.planTypeCd === 'SUPP')
      dispatch(defaultAuditCheck(use_def_audit));
  }, [use_def_audit]);

  React.useEffect(() => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      data &&
      data.length > 0 &&
      data.filter((x) => {
        return x.navTo === Messages.CREATE_NEW && x.isFormSave;
      }).length > 0
    ) {
      const list = data.map((obj) => {
        if (obj.navTo === Messages.CREATE_NEW && obj.isFormDirty === true) {
          obj.isFormSave = false;
          if (saveValidation()) saveRebateDetails(null, true);
        }
        return obj;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(list));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  React.useEffect(() => {
    if (create_err_msg && create_err_msg.length > 0) {
      tabHighLigther(Messages.CREATE_NEW, true);
    } else {
      tabHighLigther(Messages.CREATE_NEW, false);
    }
  }, [create_err_msg]);

  React.useEffect(() => {
    if (create_ura_grid_data) {
      let srcerr = create_ura_grid_data.rpcUraSource.filter(
        (o) => o.startQtrMsg
      );
      srcerr = srcerr.length > 0 ? true : false;
      setUraSrcErr(srcerr);
      let calcerr = [
        ...create_ura_grid_data.rpcUraCal.filter((o) => o.effectiveQtrMsg),
        ...create_ura_grid_data.rpcUraCal.filter((o) => o.calcMethodCdMsg),
        ...create_ura_grid_data.rpcUraCal.filter((o) => o.calcGenericPctMsg),
        ...create_ura_grid_data.rpcUraCal.filter((o) => o.calcFixedPctMsg),
      ];
      calcerr = calcerr.length > 0 ? true : false;
      setUraCalcErr(calcerr);
      let payerr = create_ura_grid_data.rpcUrPayment.filter(
        (o) => o.startQtrMsg
      );
      payerr = payerr.length > 0 ? true : false;
      setUraPayErr(payerr);

      // Get laser qtr from ura source
      if (create_ura_grid_data?.rpcUraSource.length > 0) {
        const laserQtr = _.minBy(create_ura_grid_data.rpcUraSource, (o) => {
          return checkQuarterValidation(o.startQtr) &&
            o.rpcParamValue === 'CALC'
            ? new Date(convertQuaterToDate(o.startQtr))
            : null;
        });

        dispatch({
          type: actionType.CR_LAST_URA_SRC_CALC_QTR,
          payload: laserQtr?.startQtr || '',
        });
      }
    }
  }, [create_ura_grid_data]);

  React.useEffect(() => {
    if (enroll_data && enroll_data.length > 0) {
      let err = [
        ...enroll_data.filter((o) => o.qtrMsg),
        ...enroll_data.filter((o) => o.timingcdMsg),
      ];
      err = err.length > 0 ? true : false;
      setEnrollErr(err);
    }
  }, [enroll_data]);

  React.useEffect(() => {
    if (int_grid_data) {
      let srcerr = [
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.effectiveQtrMsg
        ),
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.calcMethodCdMsg
        ),
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.calcFixedPctMsg
        ),
      ];
      srcerr = srcerr.length > 0 ? true : false;
      setIntCalErr(srcerr);
      let calcerr = [
        ...int_grid_data.rpcCalcPctVOIntShareFedaralList.filter(
          (o) => o.startQtrMsg
        ),
        ...int_grid_data.rpcCalcPctVOIntShareFedaralList.filter(
          (o) => o.rpcParamValueMsg
        ),
      ];
      calcerr = calcerr.length > 0 ? true : false;
      setIntFedErr(calcerr);
      let payerr = [
        ...int_grid_data.rpcParamVoIntShareFedaralFamiliList.filter(
          (o) => o.startQtrMsg
        ),
        ...int_grid_data.rpcParamVoIntShareFedaralFamiliList.filter(
          (o) => o.rpcParamValueMsg
        ),
      ];
      payerr = payerr.length > 0 ? true : false;
      setIntFmlyErr(payerr);
    }
  }, [int_grid_data]);

  React.useEffect(() => {
    if (group_data) {
      let srcerr = [
        ...group_data.cmsReporting.filter((o) => o.startQtrMsg),
        ...group_data.cmsReporting.filter((o) => o.endQtrMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptGroupNumMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptGroupNameMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptTitleMsg),
      ];
      srcerr = srcerr.length > 0 ? true : false;
      setCmsRptErr(srcerr);
      let calcerr = [
        ...group_data.cmsUtilization.filter((o) => o.startQtrMsg),
        ...group_data.cmsUtilization.filter((o) => o.endQtrMsg),
        ...group_data.cmsUtilization.filter((o) => o.cmsUtilGroupNumMsg),
        ...group_data.cmsUtilization.filter((o) => o.cmsUtilGroupNameMsg),
      ];
      calcerr = calcerr.length > 0 ? true : false;
      setCmsUtilErr(calcerr);
    }
  }, [group_data]);

  React.useEffect(() => {
    if (def_override) {
      let data = { ...create_pgm_detail, ...def_override };
      dispatch(createRebatePgmDetail(data));
      dispatch({
        type: actionType.COPY_CREATE_REBATE_PGM_DETAIL,
        payload: JSON.stringify(data),
      });
    }
  }, [def_override]);

  React.useEffect(() => {
    if (audit_grid_data) {
      if (default_audit) {
        let aud = defaultDataForAudits(def_sys_aud, unit_type, true);
        dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: aud.audit });
        dispatch({
          type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
          payload: aud.unitData,
        });
      } else if (!default_audit && create_pgm_detail.planTypeCd === 'SUPP') {
        let data = auditTabDataCons(audit_grid_data);
        dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: data });
      } else {
        let data = auditTabDataCons(audit_grid_data);
        dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: data });
        dispatch({
          type: actionType.CR_COPY_AUDIT_GRID_DATA,
          payload: JSON.stringify(data),
        });
      }
    }
  }, [audit_grid_data]);

  React.useEffect(() => {
    if (default_audit && create_pgm_detail.planTypeCd === 'SUPP') {
      let aud = defaultDataForAudits(def_sys_aud, unit_type, true);
      dispatch({ type: actionType.CR_CONS_AUDIT_DATA, payload: aud.audit });
      dispatch({
        type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
        payload: aud.unitData,
      });
    } else if (
      !default_audit &&
      create_pgm_detail.planTypeCd === 'SUPP' &&
      create_pgm_detail.claimRebateProgramCd
    ) {
      dispatch(getAuditGridList(create_pgm_detail.claimRebateProgramCd));
      dispatch(
        getUnitTypeAuditGridList(create_pgm_detail.claimRebateProgramCd)
      );
    }
  }, [default_audit, create_pgm_detail?.claimRebateProgramCd]);

  React.useEffect(() => {
    if (unit_type_data) {
      let err = [
        ...unit_type_data.filter((o) => o.testAmtErr),
        ...unit_type_data.filter((o) => o.mailOrderMultiplierErr),
      ];
      setUnitErr(err.length);
      if (!default_audit && create_pgm_detail.planTypeCd === 'SUPP') {
        dispatch({
          type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
          payload: unit_type_data,
        });
      } else if (!default_audit && create_pgm_detail.planTypeCd !== 'SUPP') {
        dispatch({
          type: actionType.CR_COPY_UNIT_TYPE_DATA,
          payload: JSON.stringify(unit_type_data),
        });
      }
    }
  }, [unit_type_data]);

  return (
    <div className="tabs-container" data-testid="createRebate">
      <Spinner load={load} />
      <div className="invoice_container tBillPanel">
        <Spinner load={false} />
        <CustomSeparator
          parent1="Maintain"
          parent2="Rebate Program"
          parent3="Rebate Program Create New"
        />
        <DisplaySuccessMessages successMessages={saveMsg} />
        <ErrorMessages errorMessages={create_err_msg} />
        <div className="row">
          {!fullScreen && !tabFullSrn && (
            <>
              <div className="col-12 col-md-5 mt-2">
                <div className="frr-two-col-radio">
                  <RadioGroupComponent
                    labelName={'Plan Type'}
                    optionList={radioList || []}
                    data-testid="radioType"
                    rebateprgcustomcls
                    defaultValue={create_pgm_detail?.planTypeCd || plan_type}
                    reqColor={true}
                    filterAction={(e) => {
                      dispatch({
                        type: actionType.CUSTOME_RESET_CREATE_PGM,
                        payload: { planTypeCd: e },
                      });

                      // Adjustment Quarter value set default to prior if plan type is Medicaid
                      // let data = { ...create_pgm_detail };
                      let data = {};
                      data['planTypeCd'] = e;
                      data['adjustmentQtrCd'] = e === 'FD' ? 'P' : '';
                      data['rebateUnitTypeCd'] =
                        e === 'ST' || e === 'COMM' ? 'UTIL' : '-1';

                      dispatch(createRebatePgmDetail(data));
                      dispatch(saveEnable(false));

                      // Clear all error on change of plan type
                      dispatch(createRebateErrorMsg([]));
                      dispatch(createFieldErr({}));

                      setCmsRptErr(false);
                      setCmsUtilErr(false);
                      setEnrollErr(false);
                    }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-7 mt-3">
                <fieldset className="frr-fieldset-padding">
                  <legend aria-hidden="true" className="d-none" />
                  <div className="row align-items-center">
                    <div className=" col-sm-12 col-md-4 col-lg-5 col-xl-5 mr-sm-0">
                      <div className="mui-custom-form input-md mandate-fields">
                        <TextField
                          id="rebatepgm45"
                          label="Rebate Program Code"
                          required
                          data-testid="rebateProgram"
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ maxLength: 10, id: 'rebatepgm45' }}
                          value={create_pgm_detail?.rebateProgramCd || ''}
                          onChange={(e) =>
                            changeHandler(e.target.value, 'rebateProgramCd')
                          }
                          onBlur={(e) => {
                            if (e.target.value) {
                              isValidRebatePgm({
                                rebateProgramCode: e.target.value,
                              }).then((isValid) => {
                                blurHandler(
                                  create_pgm_detail?.rebateProgramCd,
                                  'rebateProgramCd',
                                  isValid
                                );

                                dispatch({
                                  type: actionType.IS_VALID_REBETE_PGM,
                                  payload: isValid,
                                });
                              });
                            } else {
                              blurHandler(e.target.value, 'rebateProgramCd');
                            }
                          }}
                          helperText={
                            create_fld_err?.rebatePgmInvalidErr
                              ? Messages.REBETE_PGM_INVALID_ERR
                              : create_fld_err?.rebatePgmErr
                              ? Messages.REBETE_PGM_ERR
                              : null
                          }
                          error={
                            create_fld_err?.rebatePgmErr ||
                            create_fld_err?.rebatePgmInvalidErr
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-7 col-lg-6 col-xl-7 ml-xl-0 mt-xl-4 px-sm-0 px-xl-3">
                      <div className="dif mt-0 mt-md-3 ml-4 ml-md-3 ml-lg-2 mt-lg-0">
                        <FormControlLabel
                          control={<Checkbox color="primary" />}
                          label="Use default Audits"
                          value={default_audit}
                          onChange={(e, val) => {
                            if (val) setConfimPopup(true);
                            else dispatch(defaultAuditCheck(val));
                            makeItDirty();
                          }}
                          disabled={
                            create_pgm_detail?.planTypeCd === 'COMM' ||
                            create_pgm_detail?.planTypeCd === 'SUPP'
                          }
                          checked={default_audit}
                          data-testid="check-box-change"
                        />
                        <div className="comment-sec pb-1">
                          Comments {''}{' '}
                          <img
                            role="button"
                            alt="comment"
                            src={
                              comment_flag?.length
                                ? CommentVisibleIcon
                                : CommentIcon
                            }
                            disabled={!created_flag}
                            onClick={() =>
                              commentsData(
                                true,
                                'REBATE_PROGRAM_CD',
                                create_pgm_detail?.corrLinkId
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="btn-wrapper float-right pb-2 ">
                      <Button
                        className="btn btn-success bottomd"
                        data-testid="saveValidation"
                        onClick={() => {
                          if (saveValidation()) setSaveView(true);
                        }}
                        disabled={save_disable}
                      >
                        <SVGComponent iconName="Icon-outline-add-circle" />{' '}
                        Create
                      </Button>
                      <Button
                        className="btn btn-cancel bottomd"
                        data-testid="cancelView"
                        onClick={() => setCancelView(true)}
                        disabled={save_disable}
                      >
                        <SVGComponent iconName="Icon-cancel" /> Cancel
                      </Button>
                    </div>
                  </div>
                </fieldset>
              </div>
            </>
          )}

          <div className="col-sm-12 mt-2">
            {!fullScreen && (
              <div className="mt-5">
                <div className="row align-items-center">
                  <div className="frr-custom-rebatePrg-tab-wrap col-sm-12 col-xl-10 mb-4 mt-2  ">
                    <AppBar
                      position="static"
                      sx={{ width: '100%' }}
                      style={{ borderBottom: '1px solid #c9c8c5' }}
                    >
                      <Tabs
                        value={activeTab}
                        data-testid="scrollable"
                        onChange={(ev, val) => {
                          dispatch(tabValue(val));
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{ width: '89%' }}
                      >
                        <Tab
                          style={capstyle}
                          value="one"
                          label="Details"
                          tabIndex={0}
                        />
                        {Object.keys(create_fld_err).some(
                          (o) =>
                            Messages.DTLS_ERR.indexOf(o) !== -1 &&
                            create_fld_err[o] === true
                        ) && <span className="tab-error">!</span>}

                        <Tab
                          style={capstyle}
                          value="two"
                          label="Invoice Details"
                          tabIndex={0}
                        />
                        {Object.keys(create_fld_err).some(
                          (o) =>
                            Messages.INVOICE_ERR.indexOf(o) !== -1 &&
                            create_fld_err[o] === true
                        ) && <span className="tab-error">!</span>}

                        <Tab
                          style={capstyle}
                          value="three"
                          label="URA"
                          tabIndex={0}
                        />
                        {(uraCalcErr || uraPayErr || uraSrcErr) && (
                          <span className="tab-error">!</span>
                        )}
                        <Tab
                          style={capstyle}
                          value="four"
                          label="Int/Share"
                          tabIndex={0}
                        />
                        {(intCalErr || intFederr || intFmlyErr) && (
                          <span className="tab-error">!</span>
                        )}
                        <Tab
                          style={capstyle}
                          value="five"
                          label="Default/Override"
                        />
                        {Object.keys(create_fld_err).some(
                          (o) =>
                            Messages.OVRD_ERR.indexOf(o) !== -1 &&
                            create_fld_err[o] === true
                        ) && <span className="tab-error">!</span>}

                        <Tab style={capstyle} value="six" label="Audits" />
                        {Object.keys(create_fld_err).some(
                          (o) =>
                            Messages.AUDIT_ERR.indexOf(o) !== -1 &&
                            create_fld_err[o] === true
                        ) && <span className="tab-error">!</span>}

                        <Tab
                          style={capstyle}
                          value="seven"
                          label="Unit Type Audits"
                          tabIndex={0}
                        />
                        {unitErr && <span className="tab-error">!</span>}
                        <Tab
                          style={capstyle}
                          value="eight"
                          label="Group"
                          tabIndex={0}
                        />
                        {(cmsRptErr || cmsUtilErr) && (
                          <span className="tab-error">!</span>
                        )}
                        {(create_pgm_detail?.planTypeCd === 'SUPP' ||
                          create_pgm_detail?.planTypeCd === 'COMM') && (
                          <Tab
                            style={capstyle}
                            value="nine"
                            label="Enrollment"
                            tabIndex={0}
                          />
                        )}
                        {enrollErr && <span className="tab-error">!</span>}
                      </Tabs>
                    </AppBar>
                  </div>
                  <div className="col-sm-12 col-xl-2 frr-border-bottom justify-content-end">
                    <div className="float-sm-right ml-sm-5 mb-sm-2 mb-lg-0 pb-2">
                      <div className="float-right th-icon-group">
                        <div className="d-flex align-items-center">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="history-tooltip">
                                View History
                              </Tooltip>
                            }
                          >
                            <div
                              className="th-icon ic-history"
                              data-testid="viewHistory"
                              onClick={handleViewHistory}
                            >
                              <span className="ic-title"> History </span>
                            </div>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="fullScreen-tooltip">
                                {tabFullSrn ? 'Minimize Screen' : 'Full Screen'}
                              </Tooltip>
                            }
                          >
                            <div
                              className={
                                tabFullSrn
                                  ? 'th-icon ic-fulScreen-exit'
                                  : 'th-icon ic-fulScreen'
                              }
                              role="button"
                              data-testid="setFullScreenView"
                              onClick={() => setTabFullSrn(!tabFullSrn)}
                            >
                              <span className="ic-title">
                                {tabFullSrn ? 'Minimize Screen' : 'Full Screen'}
                              </span>
                            </div>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'one' && (
              <DetailsTab
                changeHandler={changeHandler}
                blurHandler={blurHandler}
                flderr={create_fld_err}
                details={create_pgm_detail}
                callFrom={'createRebate'}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'two' && (
              <InvoiceDetailsTab
                changeHandler={changeHandler}
                blurHandler={blurHandler}
                flderr={create_fld_err}
                details={create_pgm_detail}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'three' && (
              <URATab
                gridData={create_ura_grid_data}
                frozenQtr={last_frozen_qtr}
                frameworkComponents={frameworkComponents}
                uraSourceAdd={uraRecordAdd}
                // uraRecordDelete={uraRecordDelete}
                uraCalcFrameworkComponents={uraCalcFrameworkComponents}
                payFrameworkComponent={payFrameworkComponent}
                handleFullScreen={handleFullScreen}
                disableUTAPayAdd={create_pgm_detail?.planTypeCd === 'FD'}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'four' && (
              <IntShareTab 
                gridData={int_grid_data}
                frameworkComponents={intCalcFrameworkComponents}
                disableIntCalAdd={create_pgm_detail?.planTypeCd === 'FD'}
                intRecordAdd={intRecordAdd}
                disableAdd={create_pgm_detail?.planTypeCd === 'COMM'}
                // disableAdd={create_pgm_detail?.planTypeCd === 'FD' && int_grid_data?.rpcParamVoIntShareIntCalList?.length > 0}
                // intRecordDelete={intRecordDelete}
                intFedaralFrameworkComponents={intFedaralFrameworkComponents}
                intFedFamilyFrameworkComponents={
                  intFedFamilyFrameworkComponents
                }
                handleFullScreen={handleFullScreen}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'five' && (
              <DefaultOverrideTab
                changeHandler={changeHandler}
                blurHandler={blurHandler}
                flderr={create_fld_err}
                details={create_pgm_detail}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'six' && (
              <AuditsTab
                defAudit={default_audit}
                data={audit_data}
                changeHandler={auditchangeHandler}
                blurHandler={blurHandler}
                flderr={create_fld_err}
                plan={create_pgm_detail?.planTypeCd}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'seven' && (
              <UnitTypeAuditTab
                gridData={unit_type_data}
                frameworkComponents={unitTypeFrameworkComponent}
                handleFullScreen={handleFullScreen}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'eight' && (
              <GroupTab
                gridData={group_data}
                cmsReportFrameworkComponents={cmsReportFrameworkComponents}
                cmsUtilFrameworkComponents={cmsUtilFrameworkComponents}
                grpRecordAdd={grpRecordAdd}
                // grpRecordDelete={grpRecordDelete}
                handleFullScreen={handleFullScreen}
                isEnablebyRole={isEnablebyRole}
              />
            )}
            {activeTab === 'nine' &&
              (create_pgm_detail?.planTypeCd === 'SUPP' ||
                create_pgm_detail?.planTypeCd === 'COMM') && (
                <EnrollmentTab
                  gridData={enroll_data}
                  enrollFrameworkComponents={enrollFrameworkComponents}
                  // enrollRecordDelete={enrollRecordDelete}
                  enrollRecordAdd={enrollRecordAdd}
                  gridParamsSet={gridParamsSet}
                  handleFullScreen={handleFullScreen}
                  isEnablebyRole={isEnablebyRole}
                />
              )}

            <div className="clearfix" />
            {/* {!fullScreen && !tabFullSrn && (
              <div className="float-right">
                <div className="btn-wrapper mt-3">
                  <Button
                    className="btn btn-success btn-search bottomd"
                    onClick={() => {
                      if (saveValidation()) setSaveView(true);
                    }}
                    disabled={save_disable}
                  >
                    <SVGComponent iconName="Icon-awesome-save" /> Save
                  </Button>
                  <Button
                    className="btn btn-cancel bottomd"
                    onClick={() => setCancelView(true)}
                    disabled={save_disable}
                  >
                    <SVGComponent iconName="Icon-cancel" /> Cancel
                  </Button>
                </div>
              </div>
            )} */}
            <SaveCancelPopup
              open={cancelView}
              title="Cancel"
              data-testid="reset-button-uc"
              onConfim={clearRebateDetails}
              onCancel={(e) => setCancelView(false)}
              moduleName=""
            />
            <SaveCancelPopup
              open={saveView}
              title="Save"
              data-testid="save-api-uc"
              onConfim={saveRebateDetails}
              onCancel={(e) => setSaveView(false)}
              moduleName=""
            />

            {showComments ? (
              <CommentAndCorrespondenceComponent
                setShowComments={async () => {
                  if (linkTable === 'REBATE_PROGRAM_CD') {
                    dispatch(
                      getExistingCorrLinkIds([corrLinkId], 'createrebate')
                    );
                  } else {
                    const result = await dispatch(
                      getExistingCorrLinkIds([corrLinkId])
                    );
                    let newVal = enroll_data.map((obj) => {
                      if (obj.corrLinkID === corrLinkId)
                        obj.cc_COMMENTS_EXIST = result?.data?.length ? 1 : 0;
                      return obj;
                    });
                    dispatch({
                      type: actionType.CR_ENROLL_GRID_DATA,
                      payload: newVal,
                    });
                    if (enrollParams) enrollParams.api.redrawRows();
                  }
                  commentsData(false, '', '');
                }}
                linkTableName={linkTable}
                corrLinkId={corrLinkId}
              />
            ) : null}
            {showViewHistory && (
              <ViewHistoryComponent
                setShowViewHistory={setShowViewHistory}
                tableName="REBATE_PROGRAM_CD"
                keyValue={keyValue}
                isSpinner
              />
            )}
            {/* <CommonModal
              open={errorPopup}
              className="dialog-420"
              viewAction
              viewHeader
              onOk={() => setErrorPopup(false)}
              okTitle="Ok"
              onClose={() => setErrorPopup(false)}
              modalTitle={Messages.MAINTAIN_REBATE_TITLE}
              childrenComponent={errorMessage}
            /> */}
            <SaveCancelPopup
              open={deleteModal}
              data-testid="cancelPopup"
              title={'Delete'}
              onConfim={(e) => deleteFromTable()}
              onCancel={(e) => setDeleteModal(false)}
              moduleName=""
            />
            <CommonModal
              open={confimPopup}
              className="dialog-420"
              viewAction
              viewHeader
              onOk={() => {
                setConfimPopup(false);
                dispatch(defaultAuditCheck(true));
                let data = { ...create_pgm_detail };
                data.useDefAuditsInd = 1;
                dispatch(createRebatePgmDetail(data));
                let aud = defaultDataForAudits(def_sys_aud, unit_type, true);
                dispatch({
                  type: actionType.CR_CONS_AUDIT_DATA,
                  payload: aud.audit,
                });
                dispatch({
                  type: actionType.CR_UNIT_TYPE_AUDIT_GRID_DATA,
                  payload: aud.unitData,
                });
              }}
              okTitle="Ok"
              onClose={() => setConfimPopup(false)}
              childrenComponent={Messages.USE_DEFAULT_CONFIRM_MSG}
              closeTitle="Cancel"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRebate;
